import { Form } from 'antd';

import { SCard } from 'app/components/StaycationUI';
import { useExperiencesCategories } from 'app/hooks/data/useExperience';

import { AccessMode } from './_components/AccessMode';
import { RelatedSpaces } from './_components/RelatedSpaces';
import { RoomService } from './_components/RoomService';

export const Access = () => {
  const form = Form.useFormInstance();

  const categoryId = Form.useWatch(['categoryId'], form);

  const { data: experienceCategories } = useExperiencesCategories();

  const category = experienceCategories?.find((c) => c.id === categoryId);

  if (!category?.spaces && !category?.accessMode && !category?.roomService) {
    return null;
  }

  return (
    <SCard title="Access" className="experience-form">
      {category.spaces && <RelatedSpaces />}
      {category.accessMode && <AccessMode />}
      {category.roomService && <RoomService />}
    </SCard>
  );
};
